import { useRef, useState } from 'react';
import Icon, { IconType } from 'components/Icon';
import SmallIconButton, { SmallIconButtonState } from '../Button/SmallIconButton';
import * as S from './styles';
import { Attachment } from 'dragonmouse-shared/interfaces';
import { Loader } from 'components/Widget/Loader';
import { useTheme } from 'styled-components';
import Lightbox from '../Lightbox';
import { VITE_FORGE_URL } from '../../../constants';

export enum ChatAttachmentTileState {
	REGULAR,
	LOADING,
}

interface ChatAttachmentTileProps {
	attachment: Attachment;
	onDelete?: () => void;
	state: ChatAttachmentTileState;
}

const ChatAttachmentTile = ({ attachment, onDelete, state }: ChatAttachmentTileProps) => {
	const theme = useTheme();
	const [isHovered, setIsHovered] = useState(false);
	const [lightboxImageUrl, setLightboxImageUrl] = useState<string | null>(null);
	const ref = useRef(null);

	if (!attachment) {
		console.error("thumbnail being shown for frame that doesn't exist");
		return null;
	}

	const isImage = attachment.contentType.startsWith('image/');
	const attachmentUrl = `${VITE_FORGE_URL}/attachment/${encodeURIComponent(
		attachment.storagePath
	)}`;

	const handleClick = () => {
		if (isImage) {
			setLightboxImageUrl(attachmentUrl);
		} else {
			window.open(attachmentUrl, '_blank');
		}
	};

	const handleDeleteClick = () => {
		onDelete?.();
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	const renderLoadingIndicator = () => {
		return (
			<S.Loader>
				<Loader width={24} height={24} />
			</S.Loader>
		);
	};

	const renderIcon = () => {
		return (
			<S.Icon>
				<Icon type={IconType.FILE} width={26} height={26} color={theme.gray[700]} />
			</S.Icon>
		);
	};

	const renderText = () => {
		return (
			<S.Text>
				<S.Filename>{attachment.filename}</S.Filename>
				<S.FileType>{attachment.contentType}</S.FileType>
			</S.Text>
		);
	};

	return (
		<>
			<S.Base
				ref={ref}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
				onClick={handleClick}
			>
				{state === ChatAttachmentTileState.LOADING ? renderLoadingIndicator() : renderIcon()}
				{renderText()}
				{isHovered && onDelete && (
					<S.DeleteIcon onClick={(e) => e.stopPropagation()}>
						<SmallIconButton
							state={SmallIconButtonState.REGULAR}
							iconType={IconType.CLOSE}
							onClick={handleDeleteClick}
						/>
					</S.DeleteIcon>
				)}
			</S.Base>
			<Lightbox imageUrl={lightboxImageUrl} onClose={() => setLightboxImageUrl(null)} />
		</>
	);
};

export default ChatAttachmentTile;
